// @flow

import React from 'react';
import Image from './image';
import { joinArrayOrGetValue } from '../../helpers';
import type { ACFImage } from '../../types/acf';

type Props = {|
  image: ACFImage,
  position: Array<string>;
|};

const srcSet = ({ sizes, url, width }: ACFImage) => [
  {
    width: sizes['medium-width'],
    url: sizes.medium,
  },
  {
    width: sizes['medium_large-width'],
    url: sizes.medium_large,
  },
  {
    width: sizes['large-width'],
    url: sizes.large,
  },
  {
    width,
    url,
  },
];

export default ({
  image,
  position,
  ...rest
}: Props) => (
  <Image
    alt={image.alt || image.title}
    originalImgWidth={image.width}
    position={joinArrayOrGetValue(position)}
    src={image.url}
    srcSet={srcSet(image)}
    page={null}
    url={null}
    {...rest}
  />
);
